import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "entity-comments" }
const _hoisted_2 = {
  key: 0,
  class: "comments-state"
}
const _hoisted_3 = {
  key: 1,
  class: "comments-state"
}
const _hoisted_4 = {
  key: 2,
  class: "comments-list"
}
const _hoisted_5 = { class: "comment-date" }
const _hoisted_6 = {
  key: 0,
  class: "comment-edited"
}
const _hoisted_7 = { class: "comment-body" }
const _hoisted_8 = { class: "comment-actions" }
const _hoisted_9 = ["disabled", "onClick"]
const _hoisted_10 = { class: "comment-message" }
const _hoisted_11 = {
  key: 0,
  class: "comment-actions"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["placeholder"]
const _hoisted_15 = { class: "comment-form-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AoAvatar = _resolveComponent("AoAvatar")!
  const _component_BasicButton = _resolveComponent("BasicButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('close')))
  }, {
    header: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.title), 1)
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.loading && _ctx.comments.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.t("loading")), 1))
          : (_ctx.comments.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.t("comments.noComments")), 1))
            : (_openBlock(), _createElementBlock("ul", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comments, (comment) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: comment.id,
                    class: "comment-item"
                  }, [
                    _createElementVNode("span", _hoisted_5, [
                      _createTextVNode(_toDisplayString(_ctx.formatDate(comment.createdAt)) + " ", 1),
                      (comment.updatedAt !== comment.createdAt)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, " (edited) "))
                        : _createCommentVNode("", true)
                    ]),
                    (comment.user)
                      ? (_openBlock(), _createBlock(_component_AoAvatar, {
                          key: 0,
                          class: "comment-avatar",
                          "user-name": _ctx.getUserName(comment.user),
                          "avatar-url": comment.user.avatarUrl ?? undefined
                        }, null, 8, ["user-name", "avatar-url"]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_7, [
                      (_ctx.editingCommentId === comment.id)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _withDirectives(_createElementVNode("textarea", {
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editingMessage) = $event)),
                              class: "comment-input comment-edit-input",
                              rows: "3",
                              onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.cancelEditing && _ctx.cancelEditing(...args)), ["esc"]))
                            }, null, 544), [
                              [_vModelText, _ctx.editingMessage]
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "comment-action",
                                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelEditing && _ctx.cancelEditing(...args)))
                              }, _toDisplayString(_ctx.t("comments.cancel")), 1),
                              _createElementVNode("button", {
                                type: "button",
                                class: "comment-action comment-action-primary",
                                disabled: !_ctx.editingMessage.trim(),
                                onClick: ($event: any) => (_ctx.saveComment(comment.id))
                              }, _toDisplayString(_ctx.t("comments.save")), 9, _hoisted_9)
                            ])
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("div", _hoisted_10, _toDisplayString(comment.message), 1),
                            (comment.isAuthor)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "comment-action",
                                    onClick: ($event: any) => (_ctx.startEditing(comment))
                                  }, _toDisplayString(_ctx.t("comments.edit")), 9, _hoisted_12),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "comment-action",
                                    onClick: ($event: any) => (_ctx.removeComment(comment.id))
                                  }, _toDisplayString(_ctx.t("comments.delete")), 9, _hoisted_13)
                                ]))
                              : _createCommentVNode("", true)
                          ], 64))
                    ])
                  ]))
                }), 128))
              ])),
        _createElementVNode("form", {
          class: "comment-form",
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newComment) = $event)),
            class: "comment-input",
            rows: "3",
            placeholder: _ctx.t('comments.placeholder')
          }, null, 8, _hoisted_14), [
            [_vModelText, _ctx.newComment]
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_BasicButton, {
              type: "submit",
              disabled: !_ctx.newComment.trim()
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("comments.submit")), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ], 32)
      ])
    ]),
    _: 1
  }))
}